const MAX_EDGE = 1600
const JPEG_QUALITY = 0.82

function loadBitmap(blob) {
  if (typeof createImageBitmap === 'function') {
    return createImageBitmap(blob, { imageOrientation: 'from-image' }).catch(() => createImageBitmap(blob))
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob)
    const image = new Image()
    image.onload = () => {
      URL.revokeObjectURL(url)
      resolve(image)
    }
    image.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error('image'))
    }
    image.src = url
  })
}

export async function prepareScanImage(blob) {
  if (!blob) throw new Error('Image manquante ou invalide.')
  const type = String(blob.type || '').toLowerCase()
  let source
  try {
    source = await loadBitmap(blob)
  } catch {
    if (type.includes('heic') || type.includes('heif')) {
      throw new Error('Format HEIC non lisible. Convertissez en JPEG ou choisissez une autre photo.')
    }
    throw new Error('Image illisible. Choisissez une photo JPEG ou PNG.')
  }
  const width = source.width || 1
  const height = source.height || 1
  const scale = Math.min(1, MAX_EDGE / Math.max(width, height))
  const canvas = document.createElement('canvas')
  canvas.width = Math.max(1, Math.round(width * scale))
  canvas.height = Math.max(1, Math.round(height * scale))
  const ctx = canvas.getContext('2d')
  ctx.drawImage(source, 0, 0, canvas.width, canvas.height)
  if (typeof source.close === 'function') source.close()
  const prepared = await new Promise((resolve, reject) => {
    canvas.toBlob((out) => (out ? resolve(out) : reject(new Error('compression'))), 'image/jpeg', JPEG_QUALITY)
  })
  return {
    blob: prepared,
    previewUrl: URL.createObjectURL(prepared),
    width: canvas.width,
    height: canvas.height,
  }
}

export async function cropPreparedImage(blob, box = {}) {
  const x = Number(box.x) || 0
  const y = Number(box.y) || 0
  const width = Number(box.width) || 0
  const height = Number(box.height) || 0
  if (!blob || width <= 0.04 || height <= 0.04) {
    return { blob, previewUrl: URL.createObjectURL(blob), width: 0, height: 0 }
  }
  const source = await loadBitmap(blob)
  const sx = Math.max(0, Math.round(x * source.width))
  const sy = Math.max(0, Math.round(y * source.height))
  const sw = Math.min(source.width - sx, Math.round(width * source.width))
  const sh = Math.min(source.height - sy, Math.round(height * source.height))
  const canvas = document.createElement('canvas')
  canvas.width = Math.max(1, sw)
  canvas.height = Math.max(1, sh)
  const ctx = canvas.getContext('2d')
  ctx.drawImage(source, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height)
  if (typeof source.close === 'function') source.close()
  const cropped = await new Promise((resolve, reject) => {
    canvas.toBlob((out) => (out ? resolve(out) : reject(new Error('crop'))), 'image/jpeg', JPEG_QUALITY)
  })
  return {
    blob: cropped,
    previewUrl: URL.createObjectURL(cropped),
    width: canvas.width,
    height: canvas.height,
  }
}

export function revokePreview(url) {
  if (url && String(url).startsWith('blob:')) URL.revokeObjectURL(url)
}
